import elm from '../elm';
import pubsub from '../pubsub';

import numberSounds from '../number-sounds';
import notes from '../notes';
import eighthNoteSvg from './eighth-note-svg';

const numbers = [...Array(20).keys(), 20, 30, 40, 50, 60, 70, 80, 90, 100];

let elScene;
let elNumbers;
let elSong;
let elNote;

function scene123() {
  elScene = elm.findOne('.scene-123');

  render(elScene);

  initEvents();
}

function initEvents() {
  elNumbers = elm.find('.number');
  elSong = elm.findOne('.song-123');
  elNote = elm.findOne('.song-123 svg');

  elm.tap(elNumbers, onTapNumber);

  elm.tap(elSong, () => {
    const randomWaveType = ['square', 'triangle', 'sine', 'sawtooth'][Math.floor(Math.random() * 4)];

    notes.playNotes(notes.notes123(), randomWaveType, 0, 200, afterNote);
  });

  elm.tap(elm.findOne('.to-abc'), () => {
    pubsub.publish('ActivateScene', ['scene-abc']);
  });

  pubsub.subscribe('KeyPress', activateNumber);
  pubsub.subscribe('ActivateScene', maybeActivateScene);
}

function afterNote(note, remainingNotes) {
  const noteCount = 24 - remainingNotes;

  if (note === 'rest') return;

  elSong.style.background = `#${Math.random().toString(16).slice(2, 8)}`;
  elNote.style.fill = `#${Math.random().toString(16).slice(2, 8)}`;

  let elNumber = elNumbers[noteCount];

  if (noteCount > 7) {
    elNumber = elNumbers[noteCount - 1];
  }

  if (noteCount === 12 || noteCount === 13 || noteCount === 14) {
    elNumber = elNumbers[11]; // eslint-disable-line prefer-destructuring
  }

  if (noteCount === 15) {
    elNumber = elNumbers[12]; // eslint-disable-line prefer-destructuring
  }

  if (noteCount > 15) {
    elNumber = elNumbers[noteCount - 4];
  }

  elNumber.classList.add('active');

  setTimeout(() => {
    elNumber.classList.remove('active');
  }, 400);

  if (remainingNotes === 0) {
    elSong.style.background = '#333';
    elNote.style.fill = '#FFF';
  }
}

function maybeActivateScene(sceneName) {
  if (sceneName === 'scene-123') {
    elScene.classList.add('active');
  } else {
    elScene.classList.remove('active');
  }
}

function activateNumber(elNumber, number) {
  elNumber = elNumber || elm.findOne(`[data-number="${number}"]`);

  if (elNumber) {
    number = number || elNumber.getAttribute('data-number');

    onOff(elNumber, () => {
      numberSounds.play(number);
    });
  }
}

function onTapNumber(event) {
  activateNumber(event.currentTarget);
}

function onOff(elTarget, callback) {
  if (elTarget.classList.toggle('active')) {
    if (callback) callback();

    setTimeout(() => {
      elTarget.classList.toggle('active', false);
      elTarget.classList.add('cooldown');

      setTimeout(() => {
        elTarget.classList.remove('cooldown');
      }, 400);
    }, 400);
  }
}

function render() {
  const numbersHTML = [];

  numbers.forEach((number) => {
    numbersHTML.push(`<div class="grid-item number" data-number="${number}"><div>${number}</div></div>`);
  });

  numbersHTML.push(`<div class="grid-item song-123"><div>${eighthNoteSvg}</div></div>`);
  numbersHTML.push('<div class="grid-item to-abc"><div>ABC<br>&circlearrowleft;</div></div>');

  elScene.innerHTML = numbersHTML.join('');
}

export default scene123;



// WEBPACK FOOTER //
// ./src/js/scenes/123.js